// extracted by mini-css-extract-plugin
export default {"footerDiv":"footer_footerDiv__YQeuS","copyright":"footer_copyright__sMLL4","tooltip":"footer_tooltip__SiYH8"};